import React, { useState, useEffect, useContext } from 'react';
import queryString, { stringify } from 'query-string';
import { useRouteMatch, RouteComponentProps } from 'react-router-dom';
import { Form, Button, Dimmer, Loader, Modal, Progress, Checkbox, Label } from 'semantic-ui-react';
import ContactInput from '../../components/ContactInput';
import { getContactDetails } from '../../../services/messageRecipients';
import './style.less'
import EnableInboundCallingModal from './progress-modal'
import {enableInboundCalling, deleteContact} from '../../../services/messageRecipients'
import InboundCallingEnableModal from './progress-modal';
import RedirectContext from '../../../contexts/RedirectContext';
import { toast } from 'react-toastify';

interface IContactDetails {
    contact: {
        name: string;
        phoneNumbers: [
            {
                number: string;
            }
        ]
    };
    contactId: string;
    reciprocalAssociationContact: string;
}



const AddressBookContactDetails = (props) => {
    // From the path take the resident and
    console.log('hello!');
    //@ts-ignore
    const { params } = useRouteMatch('/message-recipients/:messageRecipientId/address-book/contacts/:contactId');
    console.log(params)
    const [contactDetails, setContactDetails] = useState<IContactDetails|undefined>();

    const [isCallingInboundEnabling, setIsCallingInboundEnabling] = useState(false);
    const [callingInboundEnablingProgress, setCallingInboundEnablingProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        reload();
    }, [params.messageRecipientId, params.contactId]);

    const toggleRedirect = useContext(RedirectContext);



    const sendToast = (type = 'warn', message) => {
        if (type === 'success') {
            toast.success(message, {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        } else if (type === 'warn') {
            toast.warn(message, {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }
    };

    const reload = () => {
        setIsLoading(true);
        getContactDetails(params.messageRecipientId, params.contactId).then((response) => {
            console.log(response);
            setIsLoading(false);
            setContactDetails(response);
        });

    }


    const wait = async seconds => {
        return new Promise((resolve) => {
          setTimeout(resolve, seconds)
        })
      }
    
      const enableInbound = async (residentId, contactId) => {
    
        let result = null;
        for (let i = 0; i < 5; i++) {
          const waitSeconds = 1000* (1.5**i);
    
          try {
            result = await enableInboundCalling(residentId, contactId);
            console.log('result:', result)
            setCallingInboundEnablingProgress(100);
            return true;
          } catch (err) {
            console.log('error:', err);
            await wait(waitSeconds);
            setCallingInboundEnablingProgress(((1+i)/5) * 100);

          }
        }
    
        // setMakingCallsPercent(100);
    
        return null;
        
      }
    
      const submitContact = async () => {
          console.log(params.messageRecipientId, params.contactId);

          setIsCallingInboundEnabling(true);
          setCallingInboundEnablingProgress(0);
    
        try {
          const result = await enableInbound(params.messageRecipientId, params.contactId);
          if (result) {
            setIsCallingInboundEnabling(false);
            // Good toast
            sendToast('success', 'Inbound calling enabled');
          } else {
            setIsCallingInboundEnabling(false);
            sendToast('warn', 'Failed to enable inbound calling, try after sometime');
          }

          await reload();
          console.log(result);
    
        } catch (err) {
          setIsCallingInboundEnabling(false);
          console.log('err:', err);
          sendToast('warn', 'Failed to enable inbound calling, try after sometime');
        //   Bad toast, ask them to retry
        }
      }


      const navigate = (to: string) => {
          toggleRedirect(to);
          return;
      };
  

      const navigateBack=() => {
        navigate(`/message-recipients/${params.messageRecipientId}/address-book`)
      }
      
      const deleteContactForResident = async () => {
          setIsLoading(true);
          const response = await deleteContact(params.messageRecipientId, params.contactId)
          console.log(response);
          setIsLoading(false);
          sendToast('success', 'Deleted Contact successfully')
          navigateBack()

      }


    return (
        <div className="message-recipient-details relative-detail">

            {   isLoading ? 
                (
                    <Dimmer className="pt-80" active={isLoading} inverted>
                        <Loader active={isLoading} />
                    </Dimmer>): (
                        <div>
                        <Form onSubmit={() => {}} loading={false}>
                            <div className="relative-info no-border">
                                <div>
                                    <Form.Field>
                                        <Form.Input
                                            value={contactDetails?.contact.name}
                                            type="text"
                                            name="name"
                                            disabled={true}
                                            onChange={() => {}}
                                            placeholder="Name"
                                            // label="Last Name"
                                            // readOnly={!formData.canEdit}
                                            // required
                                            autoComplete="false"
                                        />
                                    </Form.Field>
                                    {
                                        contactDetails &&contactDetails.contact.phoneNumbers.map(number => 
                                            <ContactInput
                                            isDisabled={true}
                                            contact={number.number}
                                            onChange={(e) => {
                                                console.log(e);
                                            }}
                                        />
                                        )
                                    }
        
                                    <Form.Field>
                                        <Checkbox
                                            toggle
                                            checked={contactDetails?.reciprocalAssociationContact === 'ENABLED'}
                                            type="checkbox"
                                            label={`Enabled inbound calling`}
                                            className="speak2-checkbox"
                                            disabled={contactDetails?.reciprocalAssociationContact === 'ENABLED'}
                                            onChange={(event, data) => {
                                                console.log(data);
                                                const { checked } = data;
                                                if (checked) {
                                                    submitContact()
                                                }
                                            }}
                                        />
                                    </Form.Field>
                                </div>
                            </div>
                        </Form>
                        <InboundCallingEnableModal 
                             close={() => {}}
                             error=""
                             isModalOpen={isCallingInboundEnabling}
                             progress={callingInboundEnablingProgress}
                        
                        />
                        <div className="contactDetailsNav">
                        <Button onClick={navigateBack}>Go Back</Button>
                        <Button color="red" onClick={() => deleteContactForResident()}>Delete</Button>
                        </div>
                        {}
                    </div>
                    )
            }

            
        </div>
    );
};

export default AddressBookContactDetails;
